<template>
  <a-select
    :placeholder="placeholder"
    style="width: 150px"
    @change="onChange"
    allowClear
    :value="equationId"
  >
    <a-select-option v-for="(lo) in equationList" :key="lo.id" :value="lo.id">
      {{lo.name}}
    </a-select-option>
  </a-select>
</template>
<script>
export default {
  props: {
    equationId: {
      type: String,
      default: undefined
    },
    ind: {
      type: Number,
      default: 0
    },
    placeholder: {
      type: String,
      // default: '不使用方程计算'
      default: '请选择方程'
    },
    propEquationList:{
      type: Array,
      default:() => {
        return []
      }
    }
  },
  data(){
    return {
      equationList: []
    }
  },
  created(){
    if(this.propEquationList.length === 0){
      this.getCalculationList()
    }else{
      this.equationList = this.propEquationList
    }
  },
  methods:{
    getCalculationList(){
      this.$http.get('/nhf-fine/equation/list').then(res => {
        let {success, data} = res;
        if (success) {
          this.equationList = data || [];
          this.calculationId = (data[0] && data[0].id) ? data[0].id : ''
        }
      })
    },
    onChange(val){
      this.$emit('equationChange', {val,ind: this.ind});
    }
  }
}
</script>